export default "__VITE_ASSET__CmfOjuHT__"